import React from "react";
import qapi from "views_shared/app/javascript/api";
import EntityPicker from "../../entity_picker/EntityPicker";

// No subtitle: a company has no maker/title of its own, matching its represented card.
function CompanyPicker({ onCompanyPicked, onKeyDown, companiesIdsToExclude, selectRef }) {
  return (
    <EntityPicker
      resource={qapi.companies}
      select={["id", "name", "profile_image_url"]}
      toOption={(company) => ({
        label: company.name,
        value: company.id,
        imageUrl: company.profile_image_url,
      })}
      idsToExclude={companiesIdsToExclude}
      onPicked={onCompanyPicked}
      onKeyDown={onKeyDown}
      selectRef={selectRef}
    />
  );
}

export default CompanyPicker;
